'use client';

import { cn } from '@/lib/utils';
import { TrendingUp, BookOpen, Eye, Compass } from 'lucide-react';
import type { WhyBookIntent } from '@/lib/services/guide-profile-service';

const iconMap: Record<string, React.ReactNode> = {
  'trending-up': <TrendingUp className="w-4 h-4" />,
  'book-open': <BookOpen className="w-4 h-4" />,
  eye: <Eye className="w-4 h-4" />,
  compass: <Compass className="w-4 h-4" />,
};

interface WhyBookSelectorProps {
  intents: WhyBookIntent[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

export default function WhyBookSelector({ intents, selectedId, onSelect }: WhyBookSelectorProps) {
  return (
    <div className="space-y-2">
      <p className="text-sm font-medium">Why are you booking?</p>
      <div className="grid grid-cols-2 gap-2">
        {intents.map((intent) => (
          <button
            key={intent.id}
            onClick={() => onSelect(intent.id)}
            className={cn(
              'flex items-center gap-2 px-3 py-2 rounded-lg border text-left text-sm transition-colors',
              selectedId === intent.id
                ? 'border-primary bg-primary/5 text-primary'
                : 'border-border hover:border-primary/50'
            )}
          >
            {iconMap[intent.icon] || <Compass className="w-4 h-4" />}
            <span className="truncate">{intent.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
